import setReduxAction from 'modules/redux/actions/set'
import { HEADER_BANNER_DOMAIN } from 'modules/headerBanner/constants/index.js'

/**
 * Sets the banner message.
 * @param  {string} type
 * @returns {Function}
 */
export function showHeaderBannerAction ({
  id
}) {
  const value = {
    id
  }

  return setReduxAction({
    type: 'HEADER_BANNER_SHOW',
    payload: {
      path: HEADER_BANNER_DOMAIN,
      value
    }
  })
}
